/* eslint-disable no-param-reassign */
import type { Module } from 'vuex';
import type { DeferRootState, PaymentState } from '../constants';
import { env } from '@/common';

export function getPaymentModule(): Module<PaymentState, DeferRootState> {
  return {
    namespaced: true,

    state: {
      hasPaymentOrder: false,
      /** 是否展示半页 */
      showHalfPage: !env.hideHalfPage,
    },

    mutations: {
      setHasPaymentOrder(state, payload: { hasPaymentOrder: boolean }): void {
        state.hasPaymentOrder = payload.hasPaymentOrder;
      },
      setShowHalfPage(state, payload: { showHalfPage: boolean }): void {
        state.showHalfPage = payload.showHalfPage;
      },
    },
  };
}
